import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import headers from "../../utils/csvHeaders";
import { dateOptions } from "../../utils/utils";

const CSV = ({ dataWithName, children }) => {
  return (
    <CSVLink
      filename={
        dataWithName.fname && dataWithName.lname
          ? dataWithName.fname +
            " " +
            dataWithName.lname +
            "'s " +
            "CSA Student Athlete Information Form (Via Signup)"
          : "Empty Form"
      }
      data={[dataWithName]}
      headers={headers}
    >
      {children}
    </CSVLink>
  );
};
const mapStateToProps = (state, ownProps) => {
  const advocates = state.firestore.data.advocates;
  const newReqs = state.firestore.data.testNewRequests;
  const data = ownProps.data;
  let dataWithName = {};
  if (
    data &&
    Object.keys(data).length > 0 &&
    advocates &&
    Object.keys(advocates).length > 0 &&
    newReqs &&
    Object.keys(newReqs).length > 0
  ) {
    const advocate = data.advocate;
    const advocateName = advocates[advocate].name;
    const athlete = data.id;
    const athleteName = newReqs[athlete];
    const dob =
      Object.prototype.toString.call(data.dob) === "[object Date]"
        ? data.dob
        : data.dob.toDate();
    const today = new Date();
    const timestamp = `${today.toLocaleDateString(
      "en-US"
    )} ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
    dataWithName = {
      timestamp,
      date: today.toLocaleDateString("en-US"),
      dob: dob.toLocaleDateString(undefined, dateOptions),
      gmail: data.gmail,
      resides: data.resides,
      fname: athleteName.fname,
      lname: athleteName.lname,
      parentsEmail1: data.parentsEmail1,
      parentsEmail2: data.parentsEmail2,
      parentsPhone1: data.parentsPhone1,
      parentsPhone2: data.parentsPhone2,
      travelTeam: data.travelTeam,
      classYear: data.classYear,
      sport: data.sport,
      primaryPosition: data.primaryPosition,
      secondaryPosition: data.secondaryPosition,
      fatherName: data.fatherName,
      motherName: data.motherName,
      athletesPhone: data.athletesPhone,
      school: data.school,
      comment: data.comment,
      ref: data.ref,
      advocate: advocateName,
    };
  }
  return { dataWithName };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect(({ data }) => {
    if (data && Object.keys(data).length > 0) {
      if (data.advocate && data.id) {
        return [
          {
            collection: "advocates",
            where: ["id", "==", data.advocate],
          },
          {
            collection: "testNewRequests",
            where: ["id", "==", data.id],
          },
        ];
      }
    } else
      return [
        {
          collection: "advocates",
        },
        {
          collection: "testNewRequests",
        },
      ];
  })
)(CSV);
